import {PartnerSummaryModel} from '../../model/partnerSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class PartnerGetSimilarPartnersResult {
    partners: PartnerSimilarPartner[] = [];
}

export class PartnerSimilarPartner {
    partner: PartnerSummaryModel;
    reason: LovValueSummary;
}
